module.exports = __webpack_public_path__ + "static/media/dark.67403490.png";